// Auto-generated by @vm0/firewalls-generator.
// Regenerate: cd turbo && pnpm -F @vm0/firewalls-generator generate
//
// DO NOT EDIT THIS FILE MANUALLY.
import type { FirewallExecutionMetadata } from "./types";

export const FIREWALL_SERVER_EXECUTION_METADATA = {
  "adzuna": {
    "type": "adzuna",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ADZUNA_APP_KEY"
    ],
    "placeholderValues": {
      "ADZUNA_APP_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "agentmail": {
    "type": "agentmail",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "AGENTMAIL_TOKEN"
    ],
    "placeholderValues": {
      "AGENTMAIL_TOKEN": "am_c0ffee5afe10ca1c0ffee5afe10ca1c0"
    }
  },
  "agora": {
    "type": "agora",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "AGORA_CUSTOMER_ID",
      "AGORA_CUSTOMER_SECRET"
    ],
    "placeholderValues": {
      "AGORA_CUSTOMER_ID": "4259477b8362c0ffee5afe10ca1c0ff",
      "AGORA_CUSTOMER_SECRET": "c0ffee5afe10ca1c0ffee5afe10ca1c"
    }
  },
  "ahrefs": {
    "type": "ahrefs",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "AHREFS_ACCESS_TOKEN",
      "AHREFS_TOKEN"
    ],
    "placeholderValues": {
      "AHREFS_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe00",
      "AHREFS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe00"
    }
  },
  "airtable": {
    "type": "airtable",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "AIRTABLE_ACCESS_TOKEN",
      "AIRTABLE_TOKEN"
    ],
    "placeholderValues": {
      "AIRTABLE_ACCESS_TOKEN": "patCoffeeSafeL0.c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ff",
      "AIRTABLE_TOKEN": "patCoffeeSafeL0.c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ff"
    }
  },
  "alchemy": {
    "type": "alchemy",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ALCHEMY_API_KEY"
    ],
    "placeholderValues": {
      "ALCHEMY_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "altium-365": {
    "type": "altium-365",
    "billable": false,
    "baseUrlVarNames": [
      "ALTIUM365_WORKSPACE_URL"
    ],
    "baseUrlTemplates": [
      {
        "base": "${{ vars.ALTIUM365_WORKSPACE_URL }}",
        "credentialed": true,
        "hostPolicy": {
          "kind": "publicDestination"
        }
      }
    ],
    "secretPlaceholderNames": [
      "ALTIUM365_TOKEN"
    ],
    "placeholderValues": {
      "ALTIUM365_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "amadeus": {
    "type": "amadeus",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "AMADEUS_API_KEY",
      "AMADEUS_API_SECRET"
    ],
    "placeholderValues": {
      "AMADEUS_API_KEY": "Coffee5afe10ca1Coffee5afe10ca1Co",
      "AMADEUS_API_SECRET": "Safe10ca1Coffee5afe10ca1Coffee5afe"
    }
  },
  "amplitude": {
    "type": "amplitude",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "AMPLITUDE_API_KEY",
      "AMPLITUDE_SECRET_KEY"
    ],
    "placeholderValues": {
      "AMPLITUDE_API_KEY": "c0ffee5afe10ca1c0ffee5afe10ca1c0",
      "AMPLITUDE_SECRET_KEY": "5afe10ca1c0ffee5afe10ca1c0ffee5a"
    }
  },
  "anthropic-managed-agents": {
    "type": "anthropic-managed-agents",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ANTHROPIC_MANAGED_AGENTS_TOKEN"
    ],
    "placeholderValues": {
      "ANTHROPIC_MANAGED_AGENTS_TOKEN": "sk-ant-api03-CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "apify": {
    "type": "apify",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "APIFY_TOKEN"
    ],
    "placeholderValues": {
      "APIFY_TOKEN": "apify_api_CoffeeSafeLocalCoffeeSafeLocalCoffee0"
    }
  },
  "apollo": {
    "type": "apollo",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "APOLLO_TOKEN"
    ],
    "placeholderValues": {
      "APOLLO_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffee00"
    }
  },
  "asana": {
    "type": "asana",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ASANA_ACCESS_TOKEN",
      "ASANA_TOKEN"
    ],
    "placeholderValues": {
      "ASANA_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe00",
      "ASANA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe00"
    }
  },
  "ashby": {
    "type": "ashby",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ASHBY_TOKEN"
    ],
    "placeholderValues": {
      "ASHBY_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "atlascloud": {
    "type": "atlascloud",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ATLASCLOUD_API_KEY"
    ],
    "placeholderValues": {
      "ATLASCLOUD_API_KEY": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ff"
    }
  },
  "atlassian": {
    "type": "atlassian",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ATLASSIAN_TOKEN"
    ],
    "placeholderValues": {
      "ATLASSIAN_TOKEN": "ATATT3xCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal00Cof"
    }
  },
  "attio": {
    "type": "attio",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ATTIO_TOKEN"
    ],
    "placeholderValues": {
      "ATTIO_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "aviationstack": {
    "type": "aviationstack",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "AVIATIONSTACK_TOKEN"
    ],
    "placeholderValues": {
      "AVIATIONSTACK_TOKEN": "c0ffeesafelocal5afe10ca1c0ffeesa"
    }
  },
  "aws": {
    "type": "aws",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "AWS_ACCESS_KEY_ID",
      "AWS_SECRET_ACCESS_KEY",
      "AWS_SESSION_TOKEN"
    ],
    "placeholderValues": {
      "AWS_ACCESS_KEY_ID": "ASIAC0FFEE5AFE10CA1C",
      "AWS_SECRET_ACCESS_KEY": "C0ffee5afe10ca1C0ffee5afe10ca1C0ffee5afe",
      "AWS_SESSION_TOKEN": "C0ffee5afe10ca1C0ffee5afe10ca1C0ffee5afe10ca1"
    }
  },
  "axiom": {
    "type": "axiom",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "AXIOM_TOKEN"
    ],
    "placeholderValues": {
      "AXIOM_TOKEN": "xaat-c0ffee5a-fe10-ca1c-0ffe-e5afe10ca1c0"
    }
  },
  "base44": {
    "type": "base44",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BASE44_ACCESS_TOKEN",
      "BASE44_TOKEN"
    ],
    "placeholderValues": {
      "BASE44_ACCESS_TOKEN": "base44_placeholder_token",
      "BASE44_TOKEN": "base44_placeholder_token"
    }
  },
  "bentoml": {
    "type": "bentoml",
    "billable": false,
    "baseUrlVarNames": [
      "BENTO_CLOUD_API_ENDPOINT"
    ],
    "baseUrlTemplates": [
      {
        "base": "${{ vars.BENTO_CLOUD_API_ENDPOINT }}",
        "credentialed": true,
        "hostPolicy": {
          "kind": "publicDestination"
        }
      }
    ],
    "secretPlaceholderNames": [
      "BENTO_CLOUD_API_KEY"
    ],
    "placeholderValues": {
      "BENTO_CLOUD_API_KEY": "cur7hCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "bfl": {
    "type": "bfl",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BFL_API_KEY"
    ],
    "placeholderValues": {
      "BFL_API_KEY": "bfl_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "bitrefill": {
    "type": "bitrefill",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BITREFILL_TOKEN"
    ],
    "placeholderValues": {
      "BITREFILL_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "bitrix": {
    "type": "bitrix",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BITRIX_WEBHOOK_URL"
    ],
    "placeholderValues": {
      "BITRIX_WEBHOOK_URL": "https://firewall-placeholder.vm3.ai/bitrix/hook"
    }
  },
  "bland": {
    "type": "bland",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BLAND_API_KEY"
    ],
    "placeholderValues": {
      "BLAND_API_KEY": "sk-CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "box": {
    "type": "box",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BOX_ACCESS_TOKEN",
      "BOX_TOKEN"
    ],
    "placeholderValues": {
      "BOX_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal",
      "BOX_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "brave-search": {
    "type": "brave-search",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BRAVE_API_KEY"
    ],
    "placeholderValues": {
      "BRAVE_API_KEY": "BSACoffeeSafeLocalCoffeeSafe000"
    }
  },
  "brevo": {
    "type": "brevo",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BREVO_TOKEN"
    ],
    "placeholderValues": {
      "BREVO_TOKEN": "xkeysib-c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1a"
    }
  },
  "brex": {
    "type": "brex",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BREX_TOKEN"
    ],
    "placeholderValues": {
      "BREX_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "bright-data": {
    "type": "bright-data",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BRIGHTDATA_TOKEN"
    ],
    "placeholderValues": {
      "BRIGHTDATA_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ff"
    }
  },
  "browser-use": {
    "type": "browser-use",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BROWSER_USE_TOKEN"
    ],
    "placeholderValues": {
      "BROWSER_USE_TOKEN": "bu_CoffeeSafeLocalCoffeeSafeLocalCoffee"
    }
  },
  "browserbase": {
    "type": "browserbase",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BROWSERBASE_TOKEN"
    ],
    "placeholderValues": {
      "BROWSERBASE_TOKEN": "bb_CoffeeSafeLocal_CoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "browserless": {
    "type": "browserless",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BROWSERLESS_TOKEN"
    ],
    "placeholderValues": {
      "BROWSERLESS_TOKEN": "c0ffee5a-fe10-ca1c-0ffe-e5afe10ca1c0"
    }
  },
  "browserstack": {
    "type": "browserstack",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BROWSERSTACK_ACCESS_KEY",
      "BROWSERSTACK_USERNAME"
    ],
    "placeholderValues": {
      "BROWSERSTACK_ACCESS_KEY": "CoffeeSafeLocalCoffeeSa",
      "BROWSERSTACK_USERNAME": "CoffeeSafeLocalCoffe"
    }
  },
  "bubblemaps": {
    "type": "bubblemaps",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BUBBLEMAPS_API_KEY"
    ],
    "placeholderValues": {
      "BUBBLEMAPS_API_KEY": "Coffee5afe10ca1Coffee5afe10ca1Co"
    }
  },
  "buffer": {
    "type": "buffer",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BUFFER_TOKEN"
    ],
    "placeholderValues": {
      "BUFFER_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal000"
    }
  },
  "builtwith": {
    "type": "builtwith",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "BUILTWITH_TOKEN"
    ],
    "placeholderValues": {
      "BUILTWITH_TOKEN": "c0ffeesafelocal5afe10ca1c0ffeesa"
    }
  },
  "cal-com": {
    "type": "cal-com",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CALCOM_TOKEN"
    ],
    "placeholderValues": {
      "CALCOM_TOKEN": "cal_live_CoffeeSafeLocalCoffeeSafeLocalCof00a"
    }
  },
  "calendly": {
    "type": "calendly",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CALENDLY_TOKEN"
    ],
    "placeholderValues": {
      "CALENDLY_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe00"
    }
  },
  "canva": {
    "type": "canva",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CANVA_ACCESS_TOKEN",
      "CANVA_TOKEN"
    ],
    "placeholderValues": {
      "CANVA_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa0",
      "CANVA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa0"
    }
  },
  "chatwoot": {
    "type": "chatwoot",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CHATWOOT_TOKEN"
    ],
    "placeholderValues": {
      "CHATWOOT_TOKEN": "CoffeeSafeLocalCoffeeSaf"
    }
  },
  "checkr": {
    "type": "checkr",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CHECKR_TOKEN"
    ],
    "placeholderValues": {
      "CHECKR_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "clado": {
    "type": "clado",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CLADO_TOKEN"
    ],
    "placeholderValues": {
      "CLADO_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "clearbit": {
    "type": "clearbit",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CLEARBIT_TOKEN"
    ],
    "placeholderValues": {
      "CLEARBIT_TOKEN": "sk_c0ffee5afe10ca1c0ffee5afe10ca1c0"
    }
  },
  "clerk": {
    "type": "clerk",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CLERK_TOKEN"
    ],
    "placeholderValues": {
      "CLERK_TOKEN": "sk_test_CoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "clickup": {
    "type": "clickup",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CLICKUP_TOKEN"
    ],
    "placeholderValues": {
      "CLICKUP_TOKEN": "pk_1001001_COFFEESAFELOCALCOFFEESAFELOCALCOFF"
    }
  },
  "close": {
    "type": "close",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CLOSE_ACCESS_TOKEN",
      "CLOSE_TOKEN"
    ],
    "placeholderValues": {
      "CLOSE_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalC",
      "CLOSE_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalC"
    }
  },
  "cloudflare": {
    "type": "cloudflare",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CLOUDFLARE_ACCESS_TOKEN",
      "CLOUDFLARE_TOKEN"
    ],
    "placeholderValues": {
      "CLOUDFLARE_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe",
      "CLOUDFLARE_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "coda": {
    "type": "coda",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CODA_TOKEN"
    ],
    "placeholderValues": {
      "CODA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "coingecko": {
    "type": "coingecko",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "COINGECKO_TOKEN"
    ],
    "placeholderValues": {
      "COINGECKO_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "coresignal": {
    "type": "coresignal",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CORESIGNAL_TOKEN"
    ],
    "placeholderValues": {
      "CORESIGNAL_TOKEN": "Coffee5afe10ca1Coffee5afe10ca1Co"
    }
  },
  "cronlytic": {
    "type": "cronlytic",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CRONLYTIC_API_KEY"
    ],
    "placeholderValues": {
      "CRONLYTIC_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "crustdata": {
    "type": "crustdata",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CRUSTDATA_TOKEN"
    ],
    "placeholderValues": {
      "CRUSTDATA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "cursor": {
    "type": "cursor",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CURSOR_TOKEN"
    ],
    "placeholderValues": {
      "CURSOR_TOKEN": "key_c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ff"
    }
  },
  "customer-io": {
    "type": "customer-io",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "CUSTOMERIO_APP_TOKEN"
    ],
    "placeholderValues": {
      "CUSTOMERIO_APP_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeL"
    }
  },
  "daytona": {
    "type": "daytona",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DAYTONA_API_KEY"
    ],
    "placeholderValues": {
      "DAYTONA_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "db9": {
    "type": "db9",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DB9_API_KEY"
    ],
    "placeholderValues": {
      "DB9_API_KEY": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5a"
    }
  },
  "deel": {
    "type": "deel",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DEEL_ACCESS_TOKEN",
      "DEEL_TOKEN"
    ],
    "placeholderValues": {
      "DEEL_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe",
      "DEEL_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "deepseek": {
    "type": "deepseek",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DEEPSEEK_TOKEN"
    ],
    "placeholderValues": {
      "DEEPSEEK_TOKEN": "sk-c0ffee5afe10ca1c0ffee5afe10ca1c0"
    }
  },
  "defillama": {
    "type": "defillama",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DEFILLAMA_TOKEN"
    ],
    "placeholderValues": {
      "DEFILLAMA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "devto": {
    "type": "devto",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DEVTO_TOKEN"
    ],
    "placeholderValues": {
      "DEVTO_TOKEN": "CoffeeSafeLocalCoffeeSaf"
    }
  },
  "diffbot": {
    "type": "diffbot",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DIFFBOT_TOKEN"
    ],
    "placeholderValues": {
      "DIFFBOT_TOKEN": "c0ffeesafelocal5afe10ca1c0ffeesa"
    }
  },
  "dify": {
    "type": "dify",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DIFY_TOKEN"
    ],
    "placeholderValues": {
      "DIFY_TOKEN": "app-CoffeeSafeLocalCoffeeSa"
    }
  },
  "discord": {
    "type": "discord",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DISCORD_BOT_TOKEN"
    ],
    "placeholderValues": {
      "DISCORD_BOT_TOKEN": "CoffeeSafeLocalCoffeeSaf.Coffee.CoffeeSafeLocalCoffeeSafeLo"
    }
  },
  "discord-webhook": {
    "type": "discord-webhook",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DISCORD_WEBHOOK_URL"
    ],
    "placeholderValues": {
      "DISCORD_WEBHOOK_URL": "https://firewall-placeholder.vm3.ai/discord-webhook/hook"
    }
  },
  "docusign": {
    "type": "docusign",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DOCUSIGN_ACCESS_TOKEN",
      "DOCUSIGN_TOKEN"
    ],
    "placeholderValues": {
      "DOCUSIGN_ACCESS_TOKEN": "eyJ0eXAiOiJNVCIsImFsZyI6IlJTMjU2In0.CoffeeSafeLocalCoffeeSafeLocal.CoffeeSaf",
      "DOCUSIGN_TOKEN": "eyJ0eXAiOiJNVCIsImFsZyI6IlJTMjU2In0.CoffeeSafeLocalCoffeeSafeLocal.CoffeeSaf"
    }
  },
  "doppler": {
    "type": "doppler",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DOPPLER_TOKEN"
    ],
    "placeholderValues": {
      "DOPPLER_TOKEN": "dp.st.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe00"
    }
  },
  "doubao": {
    "type": "doubao",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DOUBAO_API_KEY"
    ],
    "placeholderValues": {
      "DOUBAO_API_KEY": "c0ffee5a-fe10-ca1c-0ffe-e5afe10ca1ce"
    }
  },
  "drive9": {
    "type": "drive9",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DRIVE9_TOKEN"
    ],
    "placeholderValues": {
      "DRIVE9_TOKEN": "drive9_sk_CoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "dropbox": {
    "type": "dropbox",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DROPBOX_ACCESS_TOKEN",
      "DROPBOX_TOKEN"
    ],
    "placeholderValues": {
      "DROPBOX_ACCESS_TOKEN": "sl.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe",
      "DROPBOX_TOKEN": "sl.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "dropbox-sign": {
    "type": "dropbox-sign",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DROPBOX_SIGN_TOKEN"
    ],
    "placeholderValues": {
      "DROPBOX_SIGN_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe"
    }
  },
  "duffel": {
    "type": "duffel",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "DUFFEL_TOKEN"
    ],
    "placeholderValues": {
      "DUFFEL_TOKEN": "duffel_test_CoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "e2b": {
    "type": "e2b",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "E2B_TOKEN"
    ],
    "placeholderValues": {
      "E2B_TOKEN": "e2b_CoffeeSafeLocalCoffeeSafeLocalCoffee"
    }
  },
  "elevenlabs": {
    "type": "elevenlabs",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ELEVENLABS_TOKEN"
    ],
    "placeholderValues": {
      "ELEVENLABS_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0"
    }
  },
  "etherscan": {
    "type": "etherscan",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ETHERSCAN_API_KEY"
    ],
    "placeholderValues": {
      "ETHERSCAN_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "etsy": {
    "type": "etsy",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ETSY_TOKEN"
    ],
    "placeholderValues": {
      "ETSY_TOKEN": "c0ffee5afe10ca1c0ffee5af:e10ca15afe"
    }
  },
  "exa": {
    "type": "exa",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "EXA_TOKEN"
    ],
    "placeholderValues": {
      "EXA_TOKEN": "exa_CoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "explorium": {
    "type": "explorium",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "EXPLORIUM_TOKEN"
    ],
    "placeholderValues": {
      "EXPLORIUM_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "faire": {
    "type": "faire",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "FAIRE_TOKEN"
    ],
    "placeholderValues": {
      "FAIRE_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "fal": {
    "type": "fal",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "FAL_TOKEN"
    ],
    "placeholderValues": {
      "FAL_TOKEN": "CoffeeSafeLocalC:sk_live_CoffeeSafeLocalCoffeeSafeLo"
    }
  },
  "figma": {
    "type": "figma",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "FIGMA_ACCESS_TOKEN",
      "FIGMA_TOKEN"
    ],
    "placeholderValues": {
      "FIGMA_ACCESS_TOKEN": "figd_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe",
      "FIGMA_TOKEN": "figd_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "firecrawl": {
    "type": "firecrawl",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "FIRECRAWL_TOKEN"
    ],
    "placeholderValues": {
      "FIRECRAWL_TOKEN": "fc-c0ffee5afe10ca1c0ffee5afe10ca1c0"
    }
  },
  "fireflies": {
    "type": "fireflies",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "FIREFLIES_TOKEN"
    ],
    "placeholderValues": {
      "FIREFLIES_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalC"
    }
  },
  "flightaware": {
    "type": "flightaware",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "FLIGHTAWARE_TOKEN"
    ],
    "placeholderValues": {
      "FLIGHTAWARE_TOKEN": "Coffee5afe10ca1Coffee5afe10ca1Co"
    }
  },
  "freshdesk": {
    "type": "freshdesk",
    "billable": false,
    "baseUrlVarNames": [
      "FRESHDESK_DOMAIN"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.FRESHDESK_DOMAIN }}.freshdesk.com",
        "credentialed": true
      }
    ],
    "secretPlaceholderNames": [
      "FRESHDESK_TOKEN"
    ],
    "placeholderValues": {
      "FRESHDESK_TOKEN": "CoffeeSafeLocalCoffe"
    }
  },
  "gamma": {
    "type": "gamma",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GAMMA_TOKEN"
    ],
    "placeholderValues": {
      "GAMMA_TOKEN": "sk-gamma-CoffeeSafeLocalCoffeeSafeLo"
    }
  },
  "garmin-connect": {
    "type": "garmin-connect",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GARMIN_CONNECT_ACCESS_TOKEN",
      "GARMIN_CONNECT_TOKEN"
    ],
    "placeholderValues": {
      "GARMIN_CONNECT_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe",
      "GARMIN_CONNECT_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "gemini": {
    "type": "gemini",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GEMINI_TOKEN"
    ],
    "placeholderValues": {
      "GEMINI_TOKEN": "AIzaCoffeeSafeLocalCoffeeSafeLocalCoffe"
    }
  },
  "github": {
    "type": "github",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GH_TOKEN",
      "GITHUB_ACCESS_TOKEN",
      "GITHUB_TOKEN"
    ],
    "placeholderValues": {
      "GH_TOKEN": "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",
      "GITHUB_ACCESS_TOKEN": "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",
      "GITHUB_TOKEN": "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"
    }
  },
  "gitlab": {
    "type": "gitlab",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GITLAB_TOKEN"
    ],
    "placeholderValues": {
      "GITLAB_TOKEN": "glpat-CoffeeSafeLocalCoffe"
    }
  },
  "gmail": {
    "type": "gmail",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GMAIL_ACCESS_TOKEN",
      "GMAIL_TOKEN"
    ],
    "placeholderValues": {
      "GMAIL_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GMAIL_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "gong": {
    "type": "gong",
    "billable": false,
    "baseUrlVarNames": [
      "GONG_API_BASE"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.GONG_API_BASE }}",
        "credentialed": true,
        "hostPolicy": {
          "kind": "providerOwned",
          "suffixes": [
            "gong.io"
          ]
        }
      }
    ],
    "secretPlaceholderNames": [
      "GONG_ACCESS_KEY",
      "GONG_ACCESS_KEY_SECRET"
    ],
    "placeholderValues": {
      "GONG_ACCESS_KEY": "CoffeeSafeLocalCoffeeSafeLocalCo",
      "GONG_ACCESS_KEY_SECRET": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLoca"
    }
  },
  "google-ads": {
    "type": "google-ads",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GOOGLE_ADS_ACCESS_TOKEN",
      "GOOGLE_ADS_DEVELOPER_TOKEN",
      "GOOGLE_ADS_TOKEN"
    ],
    "placeholderValues": {
      "GOOGLE_ADS_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_ADS_DEVELOPER_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_ADS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "google-analytics": {
    "type": "google-analytics",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GOOGLE_ANALYTICS_ACCESS_TOKEN",
      "GOOGLE_ANALYTICS_TOKEN"
    ],
    "placeholderValues": {
      "GOOGLE_ANALYTICS_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_ANALYTICS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "google-calendar": {
    "type": "google-calendar",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GOOGLE_CALENDAR_ACCESS_TOKEN",
      "GOOGLE_CALENDAR_TOKEN"
    ],
    "placeholderValues": {
      "GOOGLE_CALENDAR_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_CALENDAR_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "google-cloud": {
    "type": "google-cloud",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GOOGLE_CLOUD_ACCESS_TOKEN",
      "GOOGLE_CLOUD_TOKEN"
    ],
    "placeholderValues": {
      "GOOGLE_CLOUD_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_CLOUD_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "google-docs": {
    "type": "google-docs",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GOOGLE_DOCS_ACCESS_TOKEN",
      "GOOGLE_DOCS_TOKEN"
    ],
    "placeholderValues": {
      "GOOGLE_DOCS_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_DOCS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "google-drive": {
    "type": "google-drive",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GOOGLE_DRIVE_ACCESS_TOKEN",
      "GOOGLE_DRIVE_TOKEN"
    ],
    "placeholderValues": {
      "GOOGLE_DRIVE_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_DRIVE_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "google-maps": {
    "type": "google-maps",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GOOGLE_MAPS_ACCESS_TOKEN",
      "GOOGLE_MAPS_TOKEN"
    ],
    "placeholderValues": {
      "GOOGLE_MAPS_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_MAPS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "google-meet": {
    "type": "google-meet",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GOOGLE_MEET_ACCESS_TOKEN",
      "GOOGLE_MEET_TOKEN"
    ],
    "placeholderValues": {
      "GOOGLE_MEET_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_MEET_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "google-search-console": {
    "type": "google-search-console",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GOOGLE_SEARCH_CONSOLE_ACCESS_TOKEN",
      "GOOGLE_SEARCH_CONSOLE_TOKEN"
    ],
    "placeholderValues": {
      "GOOGLE_SEARCH_CONSOLE_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_SEARCH_CONSOLE_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "google-sheets": {
    "type": "google-sheets",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GOOGLE_SHEETS_ACCESS_TOKEN",
      "GOOGLE_SHEETS_TOKEN"
    ],
    "placeholderValues": {
      "GOOGLE_SHEETS_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "GOOGLE_SHEETS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "granola": {
    "type": "granola",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GRANOLA_TOKEN"
    ],
    "placeholderValues": {
      "GRANOLA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeL"
    }
  },
  "greenhouse": {
    "type": "greenhouse",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GREENHOUSE_TOKEN"
    ],
    "placeholderValues": {
      "GREENHOUSE_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "groq": {
    "type": "groq",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GROQ_TOKEN"
    ],
    "placeholderValues": {
      "GROQ_TOKEN": "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"
    }
  },
  "gumroad": {
    "type": "gumroad",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "GUMROAD_ACCESS_TOKEN",
      "GUMROAD_TOKEN"
    ],
    "placeholderValues": {
      "GUMROAD_ACCESS_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe",
      "GUMROAD_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe"
    }
  },
  "helicone": {
    "type": "helicone",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "HELICONE_TOKEN"
    ],
    "placeholderValues": {
      "HELICONE_TOKEN": "sk-helicone-c0ffee5a-fe10-ca1c-0ffe-e5afe10ca1c0"
    }
  },
  "heygen": {
    "type": "heygen",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "HEYGEN_TOKEN"
    ],
    "placeholderValues": {
      "HEYGEN_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalC"
    }
  },
  "hitem3d": {
    "type": "hitem3d",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "HITEM3D_CLIENT_ID",
      "HITEM3D_CLIENT_SECRET"
    ],
    "placeholderValues": {
      "HITEM3D_CLIENT_ID": "hitem3d_client_id_CoffeeSafeLocalCoffeeSafeLocal",
      "HITEM3D_CLIENT_SECRET": "hitem3d_client_secret_CoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "honcho": {
    "type": "honcho",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "HONCHO_API_KEY"
    ],
    "placeholderValues": {
      "HONCHO_API_KEY": "hch-v3-CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "htmlcsstoimage": {
    "type": "htmlcsstoimage",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "HCTI_API_KEY"
    ],
    "placeholderValues": {
      "HCTI_API_KEY": "c0ffee5a-fe10-ca1c-0ffe-e5afe10ca1c0"
    }
  },
  "hubspot": {
    "type": "hubspot",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "HUBSPOT_ACCESS_TOKEN",
      "HUBSPOT_TOKEN"
    ],
    "placeholderValues": {
      "HUBSPOT_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCo",
      "HUBSPOT_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCo"
    }
  },
  "hugging-face": {
    "type": "hugging-face",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "HUGGING_FACE_TOKEN"
    ],
    "placeholderValues": {
      "HUGGING_FACE_TOKEN": "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"
    }
  },
  "hume": {
    "type": "hume",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "HUME_TOKEN"
    ],
    "placeholderValues": {
      "HUME_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeL"
    }
  },
  "hunter": {
    "type": "hunter",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "HUNTER_TOKEN"
    ],
    "placeholderValues": {
      "HUNTER_TOKEN": "c0ffeesafelocalc0ffeesafelocalc0ffeesafe"
    }
  },
  "imgur": {
    "type": "imgur",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "IMGUR_CLIENT_ID"
    ],
    "placeholderValues": {
      "IMGUR_CLIENT_ID": "CoffeeSafeLocal"
    }
  },
  "infisical": {
    "type": "infisical",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "INFISICAL_TOKEN"
    ],
    "placeholderValues": {
      "INFISICAL_TOKEN": "InfisicalTokenInfisicalTokenInfisicalToken000000"
    }
  },
  "insforge": {
    "type": "insforge",
    "billable": false,
    "baseUrlVarNames": [
      "INSFORGE_DOMAIN"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.INSFORGE_DOMAIN }}",
        "credentialed": true,
        "hostPolicy": {
          "kind": "publicDestination"
        }
      }
    ],
    "secretPlaceholderNames": [
      "INSFORGE_API_KEY"
    ],
    "placeholderValues": {
      "INSFORGE_API_KEY": "ik_CoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "instagram": {
    "type": "instagram",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "INSTAGRAM_TOKEN"
    ],
    "placeholderValues": {
      "INSTAGRAM_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeL"
    }
  },
  "instantly": {
    "type": "instantly",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "INSTANTLY_API_KEY"
    ],
    "placeholderValues": {
      "INSTANTLY_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "intercom": {
    "type": "intercom",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "INTERCOM_TOKEN"
    ],
    "placeholderValues": {
      "INTERCOM_TOKEN": "dG9rOiCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "intervals-icu": {
    "type": "intervals-icu",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "INTERVALS_ICU_ACCESS_TOKEN",
      "INTERVALS_ICU_TOKEN"
    ],
    "placeholderValues": {
      "INTERVALS_ICU_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf",
      "INTERVALS_ICU_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "ironclad": {
    "type": "ironclad",
    "billable": false,
    "baseUrlVarNames": [
      "IRONCLAD_HOST"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.IRONCLAD_HOST }}",
        "credentialed": true,
        "hostPolicy": {
          "kind": "providerOwned",
          "exactHosts": [
            "ironcladapp.com",
            "na1.ironcladapp.com",
            "eu1.ironcladapp.com",
            "demo.ironcladapp.com"
          ]
        }
      }
    ],
    "secretPlaceholderNames": [
      "IRONCLAD_API_KEY"
    ],
    "placeholderValues": {
      "IRONCLAD_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "jam": {
    "type": "jam",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "JAM_TOKEN"
    ],
    "placeholderValues": {
      "JAM_TOKEN": "jam_pat_CoffeeSafeLocalCoffeeSafeLocalCoff"
    }
  },
  "jira": {
    "type": "jira",
    "billable": false,
    "baseUrlVarNames": [
      "JIRA_DOMAIN"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.JIRA_DOMAIN }}",
        "credentialed": true,
        "hostPolicy": {
          "kind": "providerOwned",
          "suffixes": [
            "atlassian.net"
          ]
        }
      }
    ],
    "secretPlaceholderNames": [
      "JIRA_API_TOKEN"
    ],
    "placeholderValues": {
      "JIRA_API_TOKEN": "Coffee5afe10ca1Coffee5af"
    }
  },
  "jotform": {
    "type": "jotform",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "JOTFORM_TOKEN"
    ],
    "placeholderValues": {
      "JOTFORM_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffe"
    }
  },
  "klaviyo": {
    "type": "klaviyo",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "KLAVIYO_TOKEN"
    ],
    "placeholderValues": {
      "KLAVIYO_TOKEN": "pk_CoffeeSafeLocalCoffeeSafeLocalCoff"
    }
  },
  "kommo": {
    "type": "kommo",
    "billable": false,
    "baseUrlVarNames": [
      "KOMMO_SUBDOMAIN"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.KOMMO_SUBDOMAIN }}.kommo.com",
        "credentialed": true
      }
    ],
    "secretPlaceholderNames": [
      "KOMMO_API_KEY"
    ],
    "placeholderValues": {
      "KOMMO_API_KEY": "kmApiKey_CoffeeSafeLocalCoffeeSafeLocalCoffee"
    }
  },
  "langfuse": {
    "type": "langfuse",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "LANGFUSE_PUBLIC_KEY",
      "LANGFUSE_SECRET_KEY"
    ],
    "placeholderValues": {
      "LANGFUSE_PUBLIC_KEY": "pk-lf-c0ffee5a-fe10-ca1c-0ffe-e5afe10ca1c0",
      "LANGFUSE_SECRET_KEY": "sk-lf-5afe10ca-1c0f-feec-0ffe-e5afe10ca1c0"
    }
  },
  "langsmith": {
    "type": "langsmith",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "LANGSMITH_TOKEN"
    ],
    "placeholderValues": {
      "LANGSMITH_TOKEN": "lsv2_pt_c0ffeesafe10ca1c0ffeesafe10ca1c0_ffee5afe"
    }
  },
  "lark": {
    "type": "lark",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "LARK_ACCESS_TOKEN",
      "LARK_TOKEN"
    ],
    "placeholderValues": {
      "LARK_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf",
      "LARK_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "line": {
    "type": "line",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "LINE_TOKEN"
    ],
    "placeholderValues": {
      "LINE_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "linear": {
    "type": "linear",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "LINEAR_ACCESS_TOKEN",
      "LINEAR_TOKEN"
    ],
    "placeholderValues": {
      "LINEAR_ACCESS_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ff",
      "LINEAR_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ff"
    }
  },
  "loops": {
    "type": "loops",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "LOOPS_TOKEN"
    ],
    "placeholderValues": {
      "LOOPS_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0"
    }
  },
  "luma": {
    "type": "luma",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "LUMA_API_KEY"
    ],
    "placeholderValues": {
      "LUMA_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalC"
    }
  },
  "luma-ai": {
    "type": "luma-ai",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "LUMA_TOKEN"
    ],
    "placeholderValues": {
      "LUMA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalC"
    }
  },
  "mailchimp": {
    "type": "mailchimp",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MAILCHIMP_ACCESS_TOKEN",
      "MAILCHIMP_TOKEN"
    ],
    "placeholderValues": {
      "MAILCHIMP_ACCESS_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0-us6",
      "MAILCHIMP_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0-us6"
    }
  },
  "mailsac": {
    "type": "mailsac",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MAILSAC_TOKEN"
    ],
    "placeholderValues": {
      "MAILSAC_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "make": {
    "type": "make",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MAKE_TOKEN"
    ],
    "placeholderValues": {
      "MAKE_TOKEN": "mkTkn-CoffeeSafeLoca-lCof-feeS-afeLocalCoff"
    }
  },
  "manus": {
    "type": "manus",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MANUS_TOKEN"
    ],
    "placeholderValues": {
      "MANUS_TOKEN": "sk_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeL"
    }
  },
  "mapbox": {
    "type": "mapbox",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MAPBOX_TOKEN"
    ],
    "placeholderValues": {
      "MAPBOX_TOKEN": "pk.eyJ1IjoiY29mZmVlc2FmZWxvY2FsIiwiYSI6ImNvZmZlZXNhZmVsb2NhbCJ9.CoffeeSafeLocal"
    }
  },
  "maskdb": {
    "type": "maskdb",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MASKDB_TOKEN"
    ],
    "placeholderValues": {
      "MASKDB_TOKEN": "mk_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLoc"
    }
  },
  "massive": {
    "type": "massive",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MASSIVE_TOKEN"
    ],
    "placeholderValues": {
      "MASSIVE_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "mathpix": {
    "type": "mathpix",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MATHPIX_APP_KEY"
    ],
    "placeholderValues": {
      "MATHPIX_APP_KEY": "c0ffeesafelocal5afe10ca1c0ffeesa"
    }
  },
  "mem0": {
    "type": "mem0",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MEM0_TOKEN"
    ],
    "placeholderValues": {
      "MEM0_TOKEN": "m0-CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "mercury": {
    "type": "mercury",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MERCURY_ACCESS_TOKEN",
      "MERCURY_TOKEN"
    ],
    "placeholderValues": {
      "MERCURY_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe",
      "MERCURY_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "meshy": {
    "type": "meshy",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MESHY_API_KEY"
    ],
    "placeholderValues": {
      "MESHY_API_KEY": "msy_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "meta-ads": {
    "type": "meta-ads",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "META_ADS_ACCESS_TOKEN",
      "META_ADS_TOKEN"
    ],
    "placeholderValues": {
      "META_ADS_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe",
      "META_ADS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "metabase": {
    "type": "metabase",
    "billable": false,
    "baseUrlVarNames": [
      "METABASE_BASE_URL"
    ],
    "baseUrlTemplates": [
      {
        "base": "${{ vars.METABASE_BASE_URL }}",
        "credentialed": true,
        "hostPolicy": {
          "kind": "publicDestination"
        }
      }
    ],
    "secretPlaceholderNames": [
      "METABASE_TOKEN"
    ],
    "placeholderValues": {
      "METABASE_TOKEN": "mb_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLoca"
    }
  },
  "microsoft-365": {
    "type": "microsoft-365",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MICROSOFT_365_ACCESS_TOKEN",
      "MICROSOFT_365_TOKEN",
      "MICROSOFT_GRAPH_TOKEN"
    ],
    "placeholderValues": {
      "MICROSOFT_365_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal",
      "MICROSOFT_365_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal",
      "MICROSOFT_GRAPH_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "minimax": {
    "type": "minimax",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MINIMAX_TOKEN"
    ],
    "placeholderValues": {
      "MINIMAX_TOKEN": "eyJhbGciOiJSUzI1NiJ9.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "miro": {
    "type": "miro",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MIRO_TOKEN"
    ],
    "placeholderValues": {
      "MIRO_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "mixpanel": {
    "type": "mixpanel",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MIXPANEL_SERVICE_ACCOUNT_SECRET",
      "MIXPANEL_SERVICE_ACCOUNT_USERNAME"
    ],
    "placeholderValues": {
      "MIXPANEL_SERVICE_ACCOUNT_SECRET": "CoffeeSafeLocalCoffeeSafeLocalCo",
      "MIXPANEL_SERVICE_ACCOUNT_USERNAME": "CoffeeSafeLocalCoffe"
    }
  },
  "modal": {
    "type": "modal",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MODAL_TOKEN_ID",
      "MODAL_TOKEN_SECRET"
    ],
    "placeholderValues": {
      "MODAL_TOKEN_ID": "ak-CoffeeSafeLocalCoffeeSafeLocalCoffee",
      "MODAL_TOKEN_SECRET": "as-CoffeeSafeLocalCoffeeSafeLocalCoffee"
    }
  },
  "monday": {
    "type": "monday",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MONDAY_ACCESS_TOKEN",
      "MONDAY_TOKEN"
    ],
    "placeholderValues": {
      "MONDAY_ACCESS_TOKEN": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkNvZmZlZVNhZmVMb2NhbCIsImlhdCI6MTUxNjIzOTAyMn0.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLoc",
      "MONDAY_TOKEN": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkNvZmZlZVNhZmVMb2NhbCIsImlhdCI6MTUxNjIzOTAyMn0.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLoc"
    }
  },
  "moss": {
    "type": "moss",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MOSS_PROJECT_ID",
      "MOSS_PROJECT_KEY"
    ],
    "placeholderValues": {
      "MOSS_PROJECT_ID": "prj_CoffeeSafeLocalCoffeeSafe",
      "MOSS_PROJECT_KEY": "msk_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "msg9": {
    "type": "msg9",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "MSG9_TOKEN"
    ],
    "placeholderValues": {
      "MSG9_TOKEN": "msg9_sk_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "n8n": {
    "type": "n8n",
    "billable": false,
    "baseUrlVarNames": [
      "N8N_BASE_URL"
    ],
    "baseUrlTemplates": [
      {
        "base": "${{ vars.N8N_BASE_URL }}/api/v1",
        "credentialed": true,
        "hostPolicy": {
          "kind": "publicDestination"
        }
      }
    ],
    "secretPlaceholderNames": [
      "N8N_TOKEN"
    ],
    "placeholderValues": {
      "N8N_TOKEN": "n8n_api_CoffeeSafeLocalCoffeeSafeLocalCo"
    }
  },
  "neon": {
    "type": "neon",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "NEON_ACCESS_TOKEN",
      "NEON_TOKEN"
    ],
    "placeholderValues": {
      "NEON_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCo",
      "NEON_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCo"
    }
  },
  "netdata": {
    "type": "netdata",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "NETDATA_TOKEN"
    ],
    "placeholderValues": {
      "NETDATA_TOKEN": "eyJhbGciOiJub25lIiwidHlwIjoiSldUIn0.eyJpc3MiOiJuZXRkYXRhIiwic3ViIjoiY29mZmVlLXNhZmUtbG9jYWwiLCJhdWQiOiJ2bTAtY29ubmVjdG9yIn0."
    }
  },
  "notion": {
    "type": "notion",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "NOTION_ACCESS_TOKEN",
      "NOTION_TOKEN"
    ],
    "placeholderValues": {
      "NOTION_ACCESS_TOKEN": "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",
      "NOTION_TOKEN": "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"
    }
  },
  "novita": {
    "type": "novita",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "NOVITA_TOKEN"
    ],
    "placeholderValues": {
      "NOVITA_TOKEN": "sk_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLoc"
    }
  },
  "nyne": {
    "type": "nyne",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "NYNE_API_KEY",
      "NYNE_API_SECRET"
    ],
    "placeholderValues": {
      "NYNE_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe",
      "NYNE_API_SECRET": "SafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "onyx": {
    "type": "onyx",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ONYX_TOKEN"
    ],
    "placeholderValues": {
      "ONYX_TOKEN": "onyx_pat_CoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "openai": {
    "type": "openai",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "OPENAI_TOKEN"
    ],
    "placeholderValues": {
      "OPENAI_TOKEN": "sk-proj-CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocaT3BlbkFJCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLoca"
    }
  },
  "openrouter": {
    "type": "openrouter",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "OPENROUTER_TOKEN"
    ],
    "placeholderValues": {
      "OPENROUTER_TOKEN": "sk-or-v1-CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "openweather": {
    "type": "openweather",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "OPENWEATHER_TOKEN"
    ],
    "placeholderValues": {
      "OPENWEATHER_TOKEN": "c0ffeesafelocal5afe10ca1c0ffeesa"
    }
  },
  "outlook-calendar": {
    "type": "outlook-calendar",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "OUTLOOK_CALENDAR_ACCESS_TOKEN",
      "OUTLOOK_CALENDAR_TOKEN"
    ],
    "placeholderValues": {
      "OUTLOOK_CALENDAR_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe",
      "OUTLOOK_CALENDAR_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "outlook-mail": {
    "type": "outlook-mail",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "OUTLOOK_MAIL_ACCESS_TOKEN",
      "OUTLOOK_MAIL_TOKEN"
    ],
    "placeholderValues": {
      "OUTLOOK_MAIL_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "OUTLOOK_MAIL_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "pandadoc": {
    "type": "pandadoc",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PANDADOC_TOKEN"
    ],
    "placeholderValues": {
      "PANDADOC_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoff"
    }
  },
  "parallel": {
    "type": "parallel",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PARALLEL_API_KEY"
    ],
    "placeholderValues": {
      "PARALLEL_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffee00"
    }
  },
  "pdf4me": {
    "type": "pdf4me",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PDF4ME_TOKEN"
    ],
    "placeholderValues": {
      "PDF4ME_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "pdfco": {
    "type": "pdfco",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PDFCO_TOKEN"
    ],
    "placeholderValues": {
      "PDFCO_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "pdforge": {
    "type": "pdforge",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PDFORGE_API_KEY"
    ],
    "placeholderValues": {
      "PDFORGE_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "people-data-labs": {
    "type": "people-data-labs",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PEOPLE_DATA_LABS_API_KEY"
    ],
    "placeholderValues": {
      "PEOPLE_DATA_LABS_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffee00"
    }
  },
  "perplexity": {
    "type": "perplexity",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PERPLEXITY_TOKEN"
    ],
    "placeholderValues": {
      "PERPLEXITY_TOKEN": "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"
    }
  },
  "pexels": {
    "type": "pexels",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PEXELS_API_KEY"
    ],
    "placeholderValues": {
      "PEXELS_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "pika": {
    "type": "pika",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PIKA_TOKEN"
    ],
    "placeholderValues": {
      "PIKA_TOKEN": "dk_PikaDevKeyPlaceholder0000000000000000"
    }
  },
  "pinecone": {
    "type": "pinecone",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PINECONE_TOKEN"
    ],
    "placeholderValues": {
      "PINECONE_TOKEN": "pcsk_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "pipedream": {
    "type": "pipedream",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PIPEDREAM_TOKEN"
    ],
    "placeholderValues": {
      "PIPEDREAM_TOKEN": "pd_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "pipedrive": {
    "type": "pipedrive",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PIPEDRIVE_TOKEN"
    ],
    "placeholderValues": {
      "PIPEDRIVE_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe"
    }
  },
  "plain": {
    "type": "plain",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PLAIN_TOKEN"
    ],
    "placeholderValues": {
      "PLAIN_TOKEN": "plainApiKey__CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLo"
    }
  },
  "plausible": {
    "type": "plausible",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PLAUSIBLE_TOKEN"
    ],
    "placeholderValues": {
      "PLAUSIBLE_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalC"
    }
  },
  "podchaser": {
    "type": "podchaser",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PODCHASER_TOKEN"
    ],
    "placeholderValues": {
      "PODCHASER_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "porkbun": {
    "type": "porkbun",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PORKBUN_API_KEY",
      "PORKBUN_SECRET_API_KEY"
    ],
    "placeholderValues": {
      "PORKBUN_API_KEY": "pk1_Coffee5afe10ca1Coffee5afe10ca1Coffee5afe10ca1Coffee5afe10ca",
      "PORKBUN_SECRET_API_KEY": "sk1_Coffee5afe10ca1Coffee5afe10ca1Coffee5afe10ca1Coffee5afe10ca"
    }
  },
  "posthog": {
    "type": "posthog",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "POSTHOG_ACCESS_TOKEN",
      "POSTHOG_TOKEN"
    ],
    "placeholderValues": {
      "POSTHOG_ACCESS_TOKEN": "phx_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCo",
      "POSTHOG_TOKEN": "phx_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCo"
    }
  },
  "printful": {
    "type": "printful",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PRINTFUL_TOKEN"
    ],
    "placeholderValues": {
      "PRINTFUL_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "prisma-postgres": {
    "type": "prisma-postgres",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PRISMA_POSTGRES_TOKEN"
    ],
    "placeholderValues": {
      "PRISMA_POSTGRES_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "productlane": {
    "type": "productlane",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PRODUCTLANE_TOKEN"
    ],
    "placeholderValues": {
      "PRODUCTLANE_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "profound": {
    "type": "profound",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PROFOUND_API_KEY"
    ],
    "placeholderValues": {
      "PROFOUND_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "pushinator": {
    "type": "pushinator",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "PUSHINATOR_TOKEN"
    ],
    "placeholderValues": {
      "PUSHINATOR_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "qdrant": {
    "type": "qdrant",
    "billable": false,
    "baseUrlVarNames": [
      "QDRANT_BASE_URL"
    ],
    "baseUrlTemplates": [
      {
        "base": "${{ vars.QDRANT_BASE_URL }}",
        "credentialed": true,
        "hostPolicy": {
          "kind": "publicDestination"
        }
      }
    ],
    "secretPlaceholderNames": [
      "QDRANT_TOKEN"
    ],
    "placeholderValues": {
      "QDRANT_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLo"
    }
  },
  "qiita": {
    "type": "qiita",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "QIITA_TOKEN"
    ],
    "placeholderValues": {
      "QIITA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "quickbooks": {
    "type": "quickbooks",
    "billable": false,
    "baseUrlVarNames": [
      "QUICKBOOKS_REALM_ID"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://quickbooks.api.intuit.com/v3/company/${{ vars.QUICKBOOKS_REALM_ID }}",
        "credentialed": true
      }
    ],
    "secretPlaceholderNames": [
      "QUICKBOOKS_ACCESS_TOKEN",
      "QUICKBOOKS_TOKEN"
    ],
    "placeholderValues": {
      "QUICKBOOKS_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal",
      "QUICKBOOKS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "railway": {
    "type": "railway",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "RAILWAY_TOKEN"
    ],
    "placeholderValues": {
      "RAILWAY_TOKEN": "c0ffee5a-fe10-ca1c-0ffe-e5afe10ca1c0"
    }
  },
  "railway-project": {
    "type": "railway-project",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "RAILWAY_PROJECT_TOKEN"
    ],
    "placeholderValues": {
      "RAILWAY_PROJECT_TOKEN": "5afe10ca-1c0f-fee5-afe1-0ca1c0ffee5a"
    }
  },
  "reap": {
    "type": "reap",
    "billable": false,
    "baseUrlVarNames": [
      "REAP_API_BASE_URL"
    ],
    "baseUrlTemplates": [
      {
        "base": "${{ vars.REAP_API_BASE_URL }}",
        "credentialed": true,
        "hostPolicy": {
          "kind": "publicDestination"
        }
      }
    ],
    "secretPlaceholderNames": [
      "REAP_API_KEY"
    ],
    "placeholderValues": {
      "REAP_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "recraft": {
    "type": "recraft",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "RECRAFT_API_TOKEN"
    ],
    "placeholderValues": {
      "RECRAFT_API_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "reddit": {
    "type": "reddit",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "REDDIT_ACCESS_TOKEN",
      "REDDIT_TOKEN"
    ],
    "placeholderValues": {
      "REDDIT_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffe",
      "REDDIT_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffe"
    }
  },
  "reducto": {
    "type": "reducto",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "REDUCTO_TOKEN"
    ],
    "placeholderValues": {
      "REDUCTO_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "render": {
    "type": "render",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "RENDER_API_KEY"
    ],
    "placeholderValues": {
      "RENDER_API_KEY": "rnd_c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1"
    }
  },
  "rentcast": {
    "type": "rentcast",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "RENTCAST_API_KEY"
    ],
    "placeholderValues": {
      "RENTCAST_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "replicate": {
    "type": "replicate",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "REPLICATE_TOKEN"
    ],
    "placeholderValues": {
      "REPLICATE_TOKEN": "r8_CoffeeSafeLocalCoffeeSafeLocalCoffee"
    }
  },
  "reportei": {
    "type": "reportei",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "REPORTEI_TOKEN"
    ],
    "placeholderValues": {
      "REPORTEI_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "resend": {
    "type": "resend",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "RESEND_TOKEN"
    ],
    "placeholderValues": {
      "RESEND_TOKEN": "re_CoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "revenuecat": {
    "type": "revenuecat",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "REVENUECAT_TOKEN"
    ],
    "placeholderValues": {
      "REVENUECAT_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "runway": {
    "type": "runway",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "RUNWAY_TOKEN"
    ],
    "placeholderValues": {
      "RUNWAY_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalC"
    }
  },
  "salesforce": {
    "type": "salesforce",
    "billable": false,
    "baseUrlVarNames": [
      "SALESFORCE_INSTANCE"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.SALESFORCE_INSTANCE }}.my.salesforce.com",
        "credentialed": true
      }
    ],
    "secretPlaceholderNames": [
      "SALESFORCE_TOKEN"
    ],
    "placeholderValues": {
      "SALESFORCE_TOKEN": "00D0c0ffee5afe1!AQEAQFCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffee"
    }
  },
  "scrapeninja": {
    "type": "scrapeninja",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SCRAPENINJA_TOKEN"
    ],
    "placeholderValues": {
      "SCRAPENINJA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "segment": {
    "type": "segment",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SEGMENT_TOKEN"
    ],
    "placeholderValues": {
      "SEGMENT_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "semrush": {
    "type": "semrush",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SEMRUSH_TOKEN"
    ],
    "placeholderValues": {
      "SEMRUSH_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "sendgrid": {
    "type": "sendgrid",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SENDGRID_TOKEN"
    ],
    "placeholderValues": {
      "SENDGRID_TOKEN": "SG.CoffeeSafeLocalCoffeeS.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLoca"
    }
  },
  "sentry": {
    "type": "sentry",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SENTRY_ACCESS_TOKEN",
      "SENTRY_TOKEN"
    ],
    "placeholderValues": {
      "SENTRY_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCo",
      "SENTRY_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCo"
    }
  },
  "serpapi": {
    "type": "serpapi",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SERPAPI_TOKEN"
    ],
    "placeholderValues": {
      "SERPAPI_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "servicenow": {
    "type": "servicenow",
    "billable": false,
    "baseUrlVarNames": [
      "SERVICENOW_INSTANCE"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.SERVICENOW_INSTANCE }}.service-now.com",
        "credentialed": true
      }
    ],
    "secretPlaceholderNames": [
      "SERVICENOW_PASSWORD",
      "SERVICENOW_USERNAME"
    ],
    "placeholderValues": {
      "SERVICENOW_PASSWORD": "CoffeeSafeLocalCoffeeSafe",
      "SERVICENOW_USERNAME": "coffee.safe.local"
    }
  },
  "shopify": {
    "type": "shopify",
    "billable": false,
    "baseUrlVarNames": [
      "SHOPIFY_SHOP"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.SHOPIFY_SHOP }}.myshopify.com",
        "credentialed": true
      }
    ],
    "secretPlaceholderNames": [
      "SHOPIFY_TOKEN"
    ],
    "placeholderValues": {
      "SHOPIFY_TOKEN": "shpat_CoffeeSafeLocalCoffeeSafeLocalCo"
    }
  },
  "shortio": {
    "type": "shortio",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SHORTIO_TOKEN"
    ],
    "placeholderValues": {
      "SHORTIO_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalC"
    }
  },
  "similarweb": {
    "type": "similarweb",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SIMILARWEB_TOKEN"
    ],
    "placeholderValues": {
      "SIMILARWEB_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "slack": {
    "type": "slack",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SLACK_ACCESS_TOKEN",
      "SLACK_TOKEN"
    ],
    "placeholderValues": {
      "SLACK_ACCESS_TOKEN": "xoxb-100100100100-1001001001001-CoffeeSafeLocalCoffeeSaf",
      "SLACK_TOKEN": "xoxb-100100100100-1001001001001-CoffeeSafeLocalCoffeeSaf"
    }
  },
  "slack-webhook": {
    "type": "slack-webhook",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SLACK_WEBHOOK_URL"
    ],
    "placeholderValues": {
      "SLACK_WEBHOOK_URL": "https://firewall-placeholder.vm3.ai/slack-webhook/hook"
    }
  },
  "slock": {
    "type": "slock",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SLOCK_ACCESS_TOKEN",
      "SLOCK_SERVER_ID",
      "SLOCK_TOKEN"
    ],
    "placeholderValues": {
      "SLOCK_ACCESS_TOKEN": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal.c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ff",
      "SLOCK_SERVER_ID": "c0ffee5a-fe10-ca1c-0ffe-e5afe10ca1c0",
      "SLOCK_TOKEN": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal.c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ff"
    }
  },
  "snowflake": {
    "type": "snowflake",
    "billable": false,
    "baseUrlVarNames": [
      "SNOWFLAKE_ACCOUNT"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.SNOWFLAKE_ACCOUNT }}.snowflakecomputing.com/api",
        "credentialed": true
      }
    ],
    "secretPlaceholderNames": [
      "SNOWFLAKE_PAT"
    ],
    "placeholderValues": {
      "SNOWFLAKE_PAT": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "sociavault": {
    "type": "sociavault",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SOCIAVAULT_TOKEN"
    ],
    "placeholderValues": {
      "SOCIAVAULT_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCof"
    }
  },
  "sponge": {
    "type": "sponge",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SPONGE_MASTER_KEY"
    ],
    "placeholderValues": {
      "SPONGE_MASTER_KEY": "sponge_master_CoffeeSafeLocalCoffeeSafeLocalCoffee"
    }
  },
  "spotify": {
    "type": "spotify",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SPOTIFY_ACCESS_TOKEN",
      "SPOTIFY_TOKEN"
    ],
    "placeholderValues": {
      "SPOTIFY_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLo",
      "SPOTIFY_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLo"
    }
  },
  "sproutgigs": {
    "type": "sproutgigs",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SPROUTGIGS_API_SECRET"
    ],
    "placeholderValues": {
      "SPROUTGIGS_API_SECRET": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "square": {
    "type": "square",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SQUARE_TOKEN"
    ],
    "placeholderValues": {
      "SQUARE_TOKEN": "EAAACoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "stability-ai": {
    "type": "stability-ai",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "STABILITY_TOKEN"
    ],
    "placeholderValues": {
      "STABILITY_TOKEN": "sk-CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "strapi": {
    "type": "strapi",
    "billable": false,
    "baseUrlVarNames": [
      "STRAPI_BASE_URL"
    ],
    "baseUrlTemplates": [
      {
        "base": "${{ vars.STRAPI_BASE_URL }}",
        "credentialed": true,
        "hostPolicy": {
          "kind": "publicDestination"
        }
      }
    ],
    "secretPlaceholderNames": [
      "STRAPI_TOKEN"
    ],
    "placeholderValues": {
      "STRAPI_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLo"
    }
  },
  "strava": {
    "type": "strava",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "STRAVA_ACCESS_TOKEN",
      "STRAVA_TOKEN"
    ],
    "placeholderValues": {
      "STRAVA_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffe",
      "STRAVA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffe"
    }
  },
  "streak": {
    "type": "streak",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "STREAK_TOKEN"
    ],
    "placeholderValues": {
      "STREAK_TOKEN": "Coffee5afe10ca1Coffee5afe10ca1Coffee5afe10"
    }
  },
  "stripe": {
    "type": "stripe",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "STRIPE_ACCESS_TOKEN",
      "STRIPE_TOKEN"
    ],
    "placeholderValues": {
      "STRIPE_ACCESS_TOKEN": "sk_live_CoffeeSafeLocalCoffeeSafeLocalCoff",
      "STRIPE_TOKEN": "sk_live_CoffeeSafeLocalCoffeeSafeLocalCoff"
    }
  },
  "supabase": {
    "type": "supabase",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SUPABASE_ACCESS_TOKEN",
      "SUPABASE_TOKEN"
    ],
    "placeholderValues": {
      "SUPABASE_ACCESS_TOKEN": "sbp_oauth_c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe",
      "SUPABASE_TOKEN": "sbp_oauth_c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe"
    }
  },
  "supadata": {
    "type": "supadata",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SUPADATA_TOKEN"
    ],
    "placeholderValues": {
      "SUPADATA_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "supermemory": {
    "type": "supermemory",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "SUPERMEMORY_API_KEY"
    ],
    "placeholderValues": {
      "SUPERMEMORY_API_KEY": "sm_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "tavily": {
    "type": "tavily",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "TAVILY_TOKEN"
    ],
    "placeholderValues": {
      "TAVILY_TOKEN": "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"
    }
  },
  "test-oauth": {
    "type": "test-oauth",
    "billable": false,
    "baseUrlVarNames": [
      "TEST_OAUTH_TENANT_ID"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.TEST_OAUTH_TENANT_ID }}.{pr}.vm6.ai/api/test/oauth-provider",
        "credentialed": true
      }
    ],
    "secretPlaceholderNames": [
      "TEST_OAUTH_ACCESS_TOKEN",
      "TEST_OAUTH_API_ACCESS_TOKEN",
      "TEST_OAUTH_TOKEN"
    ],
    "placeholderValues": {
      "TEST_OAUTH_ACCESS_TOKEN": "testoauth_placeholder_token",
      "TEST_OAUTH_API_ACCESS_TOKEN": "testoauth_placeholder_token",
      "TEST_OAUTH_TOKEN": "testoauth_placeholder_token"
    }
  },
  "testrail": {
    "type": "testrail",
    "billable": false,
    "baseUrlVarNames": [
      "TESTRAIL_INSTANCE"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.TESTRAIL_INSTANCE }}.testrail.io",
        "credentialed": true
      }
    ],
    "secretPlaceholderNames": [
      "TESTRAIL_EMAIL",
      "TESTRAIL_TOKEN"
    ],
    "placeholderValues": {
      "TESTRAIL_EMAIL": "coffee@safe-local.example.com",
      "TESTRAIL_TOKEN": "CoffeeSafeLocalCoffeeSafeLocal"
    }
  },
  "ticketmaster": {
    "type": "ticketmaster",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "TICKETMASTER_API_KEY"
    ],
    "placeholderValues": {
      "TICKETMASTER_API_KEY": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "tiktok-ads": {
    "type": "tiktok-ads",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "TIKTOK_ADS_ACCESS_TOKEN",
      "TIKTOK_ADS_TOKEN"
    ],
    "placeholderValues": {
      "TIKTOK_ADS_ACCESS_TOKEN": "act.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe",
      "TIKTOK_ADS_TOKEN": "act.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "tldv": {
    "type": "tldv",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "TLDV_TOKEN"
    ],
    "placeholderValues": {
      "TLDV_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "todoist": {
    "type": "todoist",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "TODOIST_ACCESS_TOKEN",
      "TODOIST_TOKEN"
    ],
    "placeholderValues": {
      "TODOIST_ACCESS_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5af",
      "TODOIST_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5af"
    }
  },
  "together": {
    "type": "together",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "TOGETHER_TOKEN"
    ],
    "placeholderValues": {
      "TOGETHER_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe10ca1c0ff"
    }
  },
  "tripo": {
    "type": "tripo",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "TRIPO_API_KEY"
    ],
    "placeholderValues": {
      "TRIPO_API_KEY": "tsk_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLoc"
    }
  },
  "twenty": {
    "type": "twenty",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "TWENTY_TOKEN"
    ],
    "placeholderValues": {
      "TWENTY_TOKEN": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJDb2ZmZWVTYWZlTG9jYWxDb2ZmZWVTYWZlTG9jYWxDbyIsInR5cGUiOiJBUElfS0VZIiwid29ya3NwYWNlSWQiOiJDb2ZmZWVTYWZlTG9jYWxDb2YifQ.CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLo"
    }
  },
  "twilio": {
    "type": "twilio",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "TWILIO_ACCOUNT_SID",
      "TWILIO_AUTH_TOKEN"
    ],
    "placeholderValues": {
      "TWILIO_ACCOUNT_SID": "ACCoffeeSafeLocalCoffeeSafeLocalCo",
      "TWILIO_AUTH_TOKEN": "c0ffee5afe10ca1c0ffee5afe10ca1c0"
    }
  },
  "typeform": {
    "type": "typeform",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "TYPEFORM_TOKEN"
    ],
    "placeholderValues": {
      "TYPEFORM_TOKEN": "tfp_c0ffee5afe10ca1c0ffee5afe10ca1c0ffee5afe"
    }
  },
  "v0": {
    "type": "v0",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "V0_TOKEN"
    ],
    "placeholderValues": {
      "V0_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "vercel": {
    "type": "vercel",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "VERCEL_ACCESS_TOKEN",
      "VERCEL_TOKEN"
    ],
    "placeholderValues": {
      "VERCEL_ACCESS_TOKEN": "vcp_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeL",
      "VERCEL_TOKEN": "vcp_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeL"
    }
  },
  "wandb": {
    "type": "wandb",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "WANDB_TOKEN"
    ],
    "placeholderValues": {
      "WANDB_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafe"
    }
  },
  "webflow": {
    "type": "webflow",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "WEBFLOW_ACCESS_TOKEN",
      "WEBFLOW_TOKEN"
    ],
    "placeholderValues": {
      "WEBFLOW_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffe",
      "WEBFLOW_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffe"
    }
  },
  "weread": {
    "type": "weread",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "WEREAD_TOKEN"
    ],
    "placeholderValues": {
      "WEREAD_TOKEN": "wrk-CoffeeSafeLocalCoffeeSafeLocalCoffee"
    }
  },
  "whale-alert": {
    "type": "whale-alert",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "WHALE_ALERT_API_KEY"
    ],
    "placeholderValues": {
      "WHALE_ALERT_API_KEY": "Coffee5afe10ca1Coffee5afe10ca1Co"
    }
  },
  "wix": {
    "type": "wix",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "WIX_TOKEN"
    ],
    "placeholderValues": {
      "WIX_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "workos": {
    "type": "workos",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "WORKOS_TOKEN"
    ],
    "placeholderValues": {
      "WORKOS_TOKEN": "sk_live_CoffeeSafeLocalCoffeeSafeLocalCoffee"
    }
  },
  "wrike": {
    "type": "wrike",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "WRIKE_TOKEN"
    ],
    "placeholderValues": {
      "WRIKE_TOKEN": "wrkTkn_CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLoca"
    }
  },
  "x": {
    "type": "x",
    "billable": true,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "X_ACCESS_TOKEN",
      "X_TOKEN"
    ],
    "placeholderValues": {
      "X_ACCESS_TOKEN": "AAAAAAAAAAAAAAAAAAAAAACoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffe",
      "X_TOKEN": "AAAAAAAAAAAAAAAAAAAAAACoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffe"
    }
  },
  "xero": {
    "type": "xero",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "XERO_ACCESS_TOKEN",
      "XERO_TOKEN"
    ],
    "placeholderValues": {
      "XERO_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf",
      "XERO_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSaf"
    }
  },
  "youtube": {
    "type": "youtube",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "YOUTUBE_ACCESS_TOKEN",
      "YOUTUBE_TOKEN"
    ],
    "placeholderValues": {
      "YOUTUBE_ACCESS_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa",
      "YOUTUBE_TOKEN": "ya29.A0CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "zapier": {
    "type": "zapier",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ZAPIER_TOKEN"
    ],
    "placeholderValues": {
      "ZAPIER_TOKEN": "sk-ak-CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLo"
    }
  },
  "zapsign": {
    "type": "zapsign",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ZAPSIGN_TOKEN"
    ],
    "placeholderValues": {
      "ZAPSIGN_TOKEN": "c0ffee5a-fe10-ca1c-0ffe-e5afe10c"
    }
  },
  "zendesk": {
    "type": "zendesk",
    "billable": false,
    "baseUrlVarNames": [
      "ZENDESK_SUBDOMAIN"
    ],
    "baseUrlTemplates": [
      {
        "base": "https://${{ vars.ZENDESK_SUBDOMAIN }}.zendesk.com",
        "credentialed": true
      }
    ],
    "secretPlaceholderNames": [
      "ZENDESK_API_TOKEN"
    ],
    "placeholderValues": {
      "ZENDESK_API_TOKEN": "zkTkn_CoffeeSafeLocalCoffeeSafeLocalCoffeeSa"
    }
  },
  "zep": {
    "type": "zep",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ZEP_TOKEN"
    ],
    "placeholderValues": {
      "ZEP_TOKEN": "z_CoffeeSafeLocalCoffeeSafeLocalCo"
    }
  },
  "zeptomail": {
    "type": "zeptomail",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ZEPTOMAIL_TOKEN"
    ],
    "placeholderValues": {
      "ZEPTOMAIL_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCo"
    }
  },
  "zoom": {
    "type": "zoom",
    "billable": false,
    "baseUrlVarNames": [],
    "baseUrlTemplates": [],
    "secretPlaceholderNames": [
      "ZOOM_ACCESS_TOKEN",
      "ZOOM_TOKEN"
    ],
    "placeholderValues": {
      "ZOOM_ACCESS_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal",
      "ZOOM_TOKEN": "CoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocalCoffeeSafeLocal"
    }
  }
} as const satisfies Readonly<Record<string, FirewallExecutionMetadata>>;
